import React, { FunctionComponent } from 'react'
import classnames from 'classnames'
import startCase from 'lodash/startCase'
import { Tooltip } from '../../chassis/tooltip'

import { WithLink } from './withLinkHOC'
import { RefiTransactionsTodoRow } from './refiTransactionsTodoRow'
import { utcToLocalDateTimeFormat } from '../../helpers/timeHelper'
import { Todo } from '../tasks/types'

export interface Props {
  todo: Todo
}

export const RefiTransactionsTodoCard: FunctionComponent<Props> = ({
  todo,
}) => {
  let admin: string | null = null,
    status: string

  const { mode, task, title, type } = todo

  if (task && task.assignee && task.assignee.name) {
    admin = task.assignee.name
  }

  task && task.status ? (status = task.status) : (status = todo.status)

  if (task && task.lastAction === 'REJECTED' && status !== 'PENDING') {
    status = 'REJECTED'
  }

  return (
    <div className="refi-transactions-todoCard">
      {status === 'MISSING_DATA' && task.lastAction !== 'REJECTED' ? (
        <RefiTransactionsTodoRow
          status={status}
          type={type}
          title={title}
          mode={mode}
        />
      ) : (
        <Tooltip
          triggerText={
            <RefiTransactionsTodoRow
              status={status}
              type={type}
              title={title}
              mode={mode}
            />
          }
          contentWidth={180}
        >
          <div>
            <div>{admin}</div>
            <div
              className={classnames('', {
                'tooltip__text-center': !admin,
              })}
            >
              {startCase(status)}
            </div>
            <div>
              {task && task.updatedAt
                ? utcToLocalDateTimeFormat(task.updatedAt)
                : null}
            </div>
          </div>
        </Tooltip>
      )}
    </div>
  )
}

export default WithLink(RefiTransactionsTodoCard)

RefiTransactionsTodoCard.displayName = 'RefiTransactionsTodoCard'
